import React, { Component } from 'react';
import FrontEndRoutes from "routes/FrontEndRoutes.jsx";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import logo from "assets/img/logo_frontEnd.png";
import logo_gray from "assets/img/logo_gray.png";


class HeaderPage extends Component{

  constructor(props){
    super(props);
    this.state = {
      routes : ''
    };
  };
  sortByColumn(a, colIndex){
      a.sort(sortFunction);
      function sortFunction(a, b) {
          if (a[colIndex] === b[colIndex]) {
              return 0;
          }
          else {
              return (a[colIndex] < b[colIndex]) ? -1 : 1;
          }
      }
      return a;
  }
  render(){
    const {loggedIn, musicDirector} = this.props;
    return(

      <header id="header" test={this.props.history.location.pathname} className={this.props.history.location.pathname === '/Home' || this.props.history.location.pathname === '/'?'':'no_slider'}>
        <nav className={'navbar navbar-default' + (this.props.history.location.pathname === '/Home' || this.props.history.location.pathname === '/'?' pos_abs':'')} role="navigation" data-spy="affix" data-offset-top="300">
          <div className="container">

              <div className="navbar-header">
                  <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse">
                      <span className="sr-only">Toggle navigation</span>
                      <i className="fa fa-navicon"></i>
                  </button>         

                  <a className="navbar-brand" href="/">
                    {
                      (this.props.history.location.pathname !== '/Home' && this.props.history.location.pathname !== '/') &&
                      <div>
                        <img src={logo} className="default test1" alt="logo" />
                        <img src={logo_gray} className="gray test2" alt="logoGrey" />
                      </div>
                    }

                    {
                      (this.props.history.location.pathname === '/Home' || this.props.history.location.pathname === '/')  &&
                      <img src={logo} className="default test3" alt="logo" />
                    }
                    
                    
                  </a>
              </div>


              <div className="collapse navbar-collapse navbar-ex1-collapse">
                  <ul className="nav navbar-nav navbar-right">
                      

                      {
                        FrontEndRoutes.map((prop, key) => {
                          if (!prop.redirect && prop.showMenu){
                            // console.log('prop.name', prop.path)
                            if (loggedIn && prop.path === '/Adjudicator_Comments'){
                              return (
                                ''
                              ); 
                            } else if( !loggedIn && prop.path === '/Dashboard' ){
                              // console.log('prop.name else if', prop.path)
                              return (
                                ''
                              ); 
                            }
                            else {
                              return (
                                <li key={key}>
                                  <Link to={prop.path} data-scroll="main_slider">
                                    {prop.name}
                                  </Link>
                                </li>
                              );
                            }
                          }  
                          return null;
                        })
                      }
                      {
                        loggedIn &&
                        <li className="pull-right"><a href="/Adjudicator_Comments" >{musicDirector.username}</a></li>
                      }
                  </ul>
              </div>
            </div>
        </nav>
      </header>
    );
  }
}


function mapStateToProps(state) {
    const { loading, musicDirector, loggedIn } = state.musicDirectorReducer;
    // console.log('musicDirector', musicDirector);
    return {
        loading, musicDirector, loggedIn
    };
}

const Header = connect(mapStateToProps)(HeaderPage);
export default Header;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/Header/Header.jsx